let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fva9M")).then(() => parcelRequire('honk4'));